
export const isTestMode = (): boolean =>
  window.location.href.indexOf('qa.publista.it') !== -1;

export const isDevMode = (): boolean =>
  window.location.hostname === 'localhost';

export const isProdMode = (): boolean => !isTestMode() && !isDevMode();
